// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface FileZippedViceIconSignature {
  Element: SVGSVGElement;
}

export const FileZippedViceIcon: TOC<FileZippedViceIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M20 22V7C20 5.346 18.654 4 17 4H9V3H10V1H6V3H7V4H2V9H12V6H14V17H12V14H2V19H7V20H6V22H10V20H9V19H14V22H13V24H21V22H20ZM4 7V6H10V7H4ZM4 16V17H10V16H4ZM16 16H18V14H16V16ZM16 12V10H18V12H16ZM17 6H16V8H18V7C18 6.449 17.551 6 17 6ZM18 22H16V18H18V22Z"/>
</svg>
</template>;